import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLang } from "../i18n";

export default function WhatsAppButton() {
  const { t } = useLang();
  const text = encodeURIComponent("Hello KATACO, I'm interested in one of your vehicles.");

  return (
    <motion.a
      data-testid="whatsapp-fab"
      href={`https://wa.me/40723250260?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.5, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-6 left-6 z-40 group flex items-center gap-2.5 bg-[#25D366] text-[#06130B] rounded-full p-4 sm:pl-4 sm:pr-5 shadow-[0_8px_30px_rgba(37,211,102,0.35)] hover:bg-[#2ce174] transition-colors"
      aria-label="WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping [animation-duration:2.5s] group-hover:hidden" />
      <MessageCircle size={22} className="relative" strokeWidth={2.4} />
      <span className="relative hidden sm:inline text-sm font-semibold">{t("wa.chat")}</span>
    </motion.a>
  );
}
